import { render, staticRenderFns } from "./PopupAddress.vue?vue&type=template&id=89c52cba"
import script from "./PopupAddress.vue?vue&type=script&lang=js"
export * from "./PopupAddress.vue?vue&type=script&lang=js"
import style0 from "./PopupAddress.vue?vue&type=style&index=0&id=89c52cba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports